const articles = [
    {
        title: "01. API Performance Monitoring with Prometheus and Grafana",
        link: "https://youtu.be/KC1x8JLKwxw?si=GIjO8byNHkdReqHV",
        description: "A talk on monitoring API performance with Prometheus and Grafana. Delivered at API Conf 2024, Lagos, Nigeria."
    },
    {
        title: "02. A Short Note on Resilient Systems",
        link: "https://blog.fawazharoun.com/resilient-systems",
        description: "A short note on resilient systems."
    },
    {
        title: "03. Caching - Candy in a Drawer",
        link: "https://blog.fawazharoun.com/caching-basics",
        description: "A personal reflection on caching."
    },
]

export default articles